<template>
  <article class="invoice-create-card invoice-create-concepts-card">
    <header class="invoice-create-card__head invoice-create-card__head--space">
      <h3>{{ text.create.ui.conceptsCard.title }}</h3>
      <button type="button" class="app-header-btn app-header-btn--primary" @click="$emit('add-concept')">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span>{{ text.create.ui.conceptsCard.addButton }}</span>
      </button>
    </header>

    <div class="app-table-wrap invoice-create-concepts-table-wrap">
      <div class="app-table-scroll">
        <table class="app-data-table">
          <thead>
            <tr>
              <th>{{ text.create.ui.conceptsCard.headers.qty }}</th>
              <th>{{ text.create.ui.conceptsCard.headers.unit }}</th>
              <th>{{ text.create.ui.conceptsCard.headers.concept }}</th>
              <th class="app-text-right">{{ text.create.ui.conceptsCard.headers.unitValue }}</th>
              <th class="app-text-right">{{ text.create.ui.conceptsCard.headers.amount }}</th>
              <th class="app-text-right">{{ text.create.ui.conceptsCard.headers.actions }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!Array.isArray(concepts) || concepts.length === 0">
              <td colspan="6" class="app-table-empty">{{ text.create.ui.conceptsCard.empty }}</td>
            </tr>

            <tr v-for="(concept, index) in concepts" :key="`concept-${index}`">
              <td>{{ concept.qty }}</td>
              <td>{{ concept.unit }}</td>
              <td>{{ concept.description }}</td>
              <td class="app-text-right">{{ formatAmountWithCurrency(concept.unitPrice, currency) }}</td>
              <td class="app-text-right"><strong>{{ formatAmountWithCurrency(resolveAmount(concept), currency) }}</strong></td>
              <td class="app-text-right">
                <div class="app-table-actions-inline invoice-create-concept-actions-inline">
                  <button
                    type="button"
                    class="app-table-icon-btn app-table-icon-btn--edit"
                    :title="text.create.ui.conceptsCard.actions.edit"
                    @click="$emit('edit-concept', { index, concept })"
                  >
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </button>
                  <button
                    type="button"
                    class="app-table-icon-btn app-table-icon-btn--delete"
                    :title="text.create.ui.conceptsCard.actions.delete"
                    @click="$emit('delete-concept', index)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </article>
</template>

<script>
import { formatAmountWithCurrency } from '@/utils/numberFormat';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('simpleNotes');

export default {
  name: 'SimpleNoteCreateConceptsCard',
  props: {
    concepts: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: 'MXN',
    },
  },
  emits: ['add-concept', 'edit-concept', 'delete-concept'],
  data() {
    return {
      text,
    };
  },
  methods: {
    formatAmountWithCurrency,
    resolveAmount(concept = {}) {
      return (Number(concept?.qty || 0) || 0) * (Number(concept?.unitPrice || 0) || 0);
    },
  },
};
</script>
